import { css } from '@emotion/react'
import { HitType } from '@types'
import { Loader } from '@components/utils'

import Header from './Header'
import ContributorTable from './ContributorTable'

export type ContributorsPropsType = {
  hitsAchievement: HitType[]
  isLoading?: boolean
}

const Contributor = ({ hitsAchievement, isLoading }: ContributorsPropsType) => {
  return (
    <>
      <Header data={{}} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && <ContributorTable hitsAchievement={hitsAchievement} />}
      </div>
    </>
  )
}

export default Contributor
